import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13c3bead&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c3bead')) {
      api.createRecord('13c3bead', component.options)
    } else {
      api.reload('13c3bead', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13c3bead&", function () {
      api.rerender('13c3bead', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/film-commission/index.vue"
export default component.exports